import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import uniqBy from 'lodash/uniqBy';
import get from 'lodash/get';
import store from '../redux/store/store';

import {
	OFaqSectionInfo,
	OCmsProjectTable,
	OConfirmPopup,
	ODestructiveButtons,
} from '../components/organisme';
import { setCmsHead } from '../redux/head/headActions';
import { fetchFAQAll } from '../redux/content/contentActions';
import { CMS_CONFIG } from '../config/cms.config';
import withAuthGuard from '../helpers/withAuthGuard';
import { updateForm, initForm, removeFAQItem, addFaq, updateFaq } from '../redux/cms/cmsActions';
import { MCmsLanguagePicker } from '../components/molecules';
import filterNL from '../helpers/filterNL';

import { routes } from '../constants';

const mapStateToProps = state => ({
	form: state.cms.form,
	faq: state.content.faq,
	languages: state.head.utilities.languages,
	isFetching: state.content.isFetching,
	isValid: state.cms.isFormValid,
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
});

class FaqSectionPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			confirmPopupOpen: false,
			deleteName: '',
			pendingDeleteId: undefined,
			filteredItems: undefined,
			language: undefined,
			isEditMode: false,
			items: [],
		};
	}

	componentDidMount() {
		const editMode = this.checkForEditMode();
		const onClick = `${this.props.match.url}/create`;
		if (editMode) {
			this.props.setCmsHead({ ...CMS_CONFIG.FAQ.header.section, onClick });
		} else {
			this.props.setCmsHead({ ...CMS_CONFIG.FAQ.header.section });
		}

		this.bindHandles();
		this.props.fetchFAQAll();

		this.initForm({ editMode });
	}

	componentWillReceiveProps(props) {
		if (!this.state.language && props.languages.length > 0) {
			this.setState({ language: props.languages[0].uuid });
		}

		if (this.state.isEditMode) {
			const faqCat = store.getState().content.faq.filter(item => item.id === props.match.params.slug);

			let items = get(filterNL(faqCat)[0], 'faqs', []);

			items = items.map((item) => {
				const newItem = item;
				newItem.name = item.title;
				return newItem;
			});

			this.setState({ items });
		}
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleLanguageSwitch = this.handleLanguageSwitch.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.initForm = this.initForm.bind(this);
	}
	initForm({ editMode = false }) {
		const values = {};

		if (editMode) {
			const faqCat = store.getState().content.faq.filter(item => item.id === this.props.match.params.slug);

			if (!faqCat || !faqCat.length || faqCat.length === 0) {
				this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.FAQ}`);
				return;
			}

			let items = get(filterNL(faqCat)[0], 'faqs', []);
			items = items.map((item) => {
				const newItem = item;
				newItem.name = item.title;
				return newItem;
			});
			values.id = faqCat[0].id;
			faqCat.forEach((faqCatItem) => {
				values[`${faqCatItem.languageUuid}-name`] = faqCatItem.name;
			});
			this.setState({ items });
		}

		this.props.initForm({
			fields: CMS_CONFIG.CREATE.faqCat(this.props.languages),
			values,
		});
	}

	handleSave() {
		if (!this.props.isValid) {
			return;
		}

		if (this.state.isEditMode) {
			this.props.updateFaq(this.props.history);
		} else {
			this.props.addFaq(this.props.history);
		}
	}

	checkForEditMode() {
		const isEditMode = 'slug' in this.props.match.params;

		this.setState({ isEditMode });

		return isEditMode;
	}

	handleFieldChange({ field, value, error }) {
		this.props.updateForm({ key: field, value, valid: !error });
	}

	handleLangFieldChange({ field, value, error }) {
		if (this.state.language) {
			this.props.updateForm({ key: `${this.state.language}-${field}`, value, valid: !error });
		}
	}

	handleSearch(value) {
		this.setState({ filteredItems: undefined });
		if (value) {
			const re = new RegExp(value, 'gi');
			this.setState({ filteredItems: this.state.items.filter(item => item.name.match(re)) });
		}
	}
	handleEdit(id) {
		const item = this.state.items.find(result => result.id === id);
		this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.CREATE_FAQ_SECTION}/${this.props.form.id.value}/create/${item.id}`);
	}
	handleDelete(id) {
		const foundItem = this.state.items.find(item => item.id === id);
		this.setState({
			deleteName: foundItem.name || id,
			confirmPopupOpen: true,
			pendingDeleteId: id,
		});
	}

	handleLanguageSwitch(language) {
		this.setState({ language });
	}

	handleConfirm() {
		this.props.removeFAQItem(this.state.pendingDeleteId);
		this.setState({ confirmPopupOpen: false, pendingDeleteId: undefined });
	}
	handleCancel() {
		this.setState({ confirmPopupOpen: false, pendingDeleteId: undefined });
	}

	render() {
		const popupText = `Weet u zeker dat u ${this.state.deleteName} permanent wilt verwijderen?`;

		return (
			<div className="layout-cms--content-body layout-cms--create-po layout-cms--content-body-grey">
				<div className="section-cms--language-picker">
					<MCmsLanguagePicker
						items={this.props.languages}
						active={this.state.language}
						onClick={this.handleLanguageSwitch}
					/>
				</div>
				<OFaqSectionInfo
					title={get(this.props, `form['${this.state.language}-name'].value`, '')}
					onTitleChange={(value, error) => this.handleLangFieldChange({ field: 'name', value, error })}
				/>
				{this.state.isEditMode &&
					<OCmsProjectTable
						columns={CMS_CONFIG.FAQ.table.columns}
						items={uniqBy(this.state.filteredItems || this.state.items, 'id')}
						isFetching={this.props.isFetching}
						onSearch={this.handleSearch}
						onEdit={this.handleEdit}
						onDelete={this.handleDelete}
					/>
				}

				<OConfirmPopup
					title="Bevestiging"
					text={popupText}
					confirmLabel="Ja"
					cancelLabel="Nee"
					open={this.state.confirmPopupOpen}
					onCancel={this.handleCancel}
					onConfirm={this.handleConfirm}
				/>
				<div className="section-cms--destructive-buttons">
					<ODestructiveButtons
						saveEnabled={this.props.isValid}
						onSave={this.handleSave}
						className="dark"
					/>
				</div>
			</div>
		);
	}
}

FaqSectionPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	fetchFAQAll: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	fetchFAQAll,
	removeFAQItem,
	updateForm,
	initForm,
	addFaq,
	updateFaq,
})(FaqSectionPage)));



// WEBPACK FOOTER //
// ./src/CMS/faq-section.js